import { React, Link, styled, css } from 'x'

const ButtonStyle = css`
  display: inline-block;
  min-width: 205px;
  height: 40px;
  border: 2px solid #909090;
  font-family: 'Dosis', Helvetica, Arial, sans-serif;
  font-feature-settings: 'ss03';
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  line-height: 26px;
  letter-spacing: 0.05em;
  text-align: center;
  transition: border-color 0.25s;
  background: transparent;
  color: #fff;
  cursor: pointer;
  padding: 0 20px;
  align-self: flex-start;
  box-sizing: border-box;

  &:hover {
    border-color: #fff;
  }
`

const Button = styled.button`
  ${ButtonStyle}
`

const LinkButton = styled((props) => <Link {...props} />)`
  ${ButtonStyle}

  line-height: 40px;
  text-decoration: none;
  margin-top: 6px;
`

export default Button

export { LinkButton }
